import React, { useState } from "react";

//
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";

//
import { Formik } from "formik";
import * as yup from "yup";
import PasswordStrengthMeter from "../../general/PasswordStrengthMeter";

//
import { changePassword } from "../../../redux/features/user/actions";

const schema = yup.object().shape({
  old_password: yup.string().required(),
  new_password: yup.string().required(),
  new_password_confirmation: yup
    .string()
    .required()
    .oneOf([yup.ref("new_password"), null], "Passwords must match"),
});

function ChangePasswordModal() {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [score, setScore] = useState(0);
  const [password, setPassword] = useState("");

  const [newPasswordCanSee, setNewPasswordCanSee] = useState(false);
  const [newPasswordConfirmationCanSee, setNewPasswordConfirmationCanSee] =
    useState(false);

  /**
   * Hide Modal
   * clear data when modal hide
   */
  const hideModal = () => {
    setPassword("");
    setNewPasswordCanSee(false);
    setNewPasswordConfirmationCanSee(false);

    setShow(false);
  };

  const submit_password = (e) => {
    // start loading
    setLoading(true);

    // request
    changePassword(e).then((res) => {
      if (res) {
        hideModal();

        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <>
      <Button variant="info" size="sm" onClick={() => setShow(true)}>
        Change Password
      </Button>

      <Modal centered size="lg" show={show} onHide={hideModal}>
        <Modal.Header closeButton>
          <h5>Change Password</h5>
          <p className="subject">
            Your new password must be different from previous used password
          </p>
        </Modal.Header>

        <Modal.Body>
          <Formik
            validationSchema={schema}
            onSubmit={submit_password}
            initialValues={{
              old_password: "",
              new_password: "",
              new_password_confirmation: "",
            }}
          >
            {({ handleSubmit, handleChange, touched, errors }) => (
              <Form noValidate onSubmit={handleSubmit}>
                {/* Old Password */}
                <Row>
                  <Col md={6}>
                    <Form.Group
                      className="form-group"
                      controlId="validationFormik0"
                    >
                      <Form.Label>Old Password</Form.Label>
                      <Form.Control
                        type="password"
                        name="old_password"
                        placeholder="Type here..."
                        className="form-control"
                        onChange={handleChange}
                        autoComplete="off"
                        isInvalid={
                          touched.old_password && !!errors.old_password
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* New Password */}
                <Row>
                  {/* New */}
                  <Col md={6}>
                    <Form.Group
                      className="form-group"
                      controlId="validationFormik1"
                    >
                      <Form.Label>New Password</Form.Label>
                      <div className="input-holder right">
                        <Form.Control
                          type={newPasswordCanSee ? "text" : "password"}
                          name="new_password"
                          placeholder="Type here..."
                          className="form-control"
                          onChange={(e) => {
                            handleChange(e);
                            setPassword(e.target.value);
                          }}
                          autoComplete="off"
                          isInvalid={
                            touched.new_password &&
                            (!!errors.new_password || score < 3)
                          }
                        />
                        <i
                          className={`las pointer ${
                            newPasswordCanSee ? "la-eye" : "la-eye-slash"
                          }`}
                          onClick={() =>
                            setNewPasswordCanSee(!newPasswordCanSee)
                          }
                        ></i>
                      </div>
                      <PasswordStrengthMeter
                        password={password}
                        action={(score) => setScore(score)}
                      />
                    </Form.Group>
                  </Col>

                  {/* Confirm */}
                  <Col md={6}>
                    <Form.Group
                      className="form-group"
                      controlId="validationFormik2"
                    >
                      <Form.Label>Confirm Password</Form.Label>
                      <div className="input-holder right">
                        <Form.Control
                          type={
                            newPasswordConfirmationCanSee ? "text" : "password"
                          }
                          name="new_password_confirmation"
                          placeholder="Type here..."
                          className="form-control"
                          onChange={handleChange}
                          autoComplete="off"
                          isInvalid={
                            touched.new_password_confirmation &&
                            !!errors.new_password_confirmation
                          }
                        />
                        <i
                          className={`las pointer ${
                            newPasswordConfirmationCanSee
                              ? "la-eye"
                              : "la-eye-slash"
                          }`}
                          onClick={() =>
                            setNewPasswordConfirmationCanSee(
                              !newPasswordConfirmationCanSee
                            )
                          }
                        ></i>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="actions">
                  <Button variant="info" type="submit" size="lg">
                    Continue
                    {loading && (
                      <div className="spinner-holder">
                        <Spinner animation="border" variant="white" size="sm" />
                      </div>
                    )}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ChangePasswordModal;
